/** make a string from an ip range */
export const rangeString = rowData => {
  if (!rowData) {
    return '';
  }

  let ret = rowData.LowerRange;

  if (rowData.UpperRange !== rowData.LowerRange) {
    ret += ' - ' + rowData.UpperRange;
  }

  return ret;
};



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/helpers/NetworkFilteringHelpers.js